module.exports = __webpack_public_path__ + "static/group-26-4e3aabfc540a44cf9edf96a530ea7f31.png";